// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1yh-t","selected":"Chip_selected__3MjMd"};